export const PATH = {
  PROPERTY: `property`,
  APPLICANT: `applicant`,
  FINISH: `finish`,
}
